import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from "react-router";
import { router } from './routes'
import './index.css'
import './lib/i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <RouterProvider router={router} />
  </React.StrictMode>
  // <RouterProvider router={router} />
) 